export const columnWidths = {
  name: '24%',
  email: '20%',
  person: '8%',
  sinacorAccount: '12%',
  custodyAccount: '13%',
  accountBP: '9%',
  promotionalRestriction: '14%',
};
